import { useEffect, useState } from "react";
import { BookOpen } from "lucide-react";
import api from "../lib/api";
import { useSeo } from "../lib/seo";

export default function Devotionals() {
  const [list, setList] = useState(null);
  const [open, setOpen] = useState(null);
  useSeo({ title: "Weekly Devotionals", description: "Read this week's devotional and every past Sunday's word: honest, scripture-rooted encouragement for everyday struggles, with a prayer to carry into your week.", path: "/devotionals" });
  useEffect(() => { api.get("/devotionals").then((r) => { setList(r.data); setOpen(r.data[0]?.id || null); }); }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-10 py-16" data-testid="devotionals-page">
      <div className="overline text-[#d4af37]">The archive</div>
      <h1 className="font-serif text-5xl mt-3 text-[#0a192f] tracking-tight">Weekly Devotionals</h1>
      <p className="text-[#4a4a4a] mt-4 max-w-2xl">A fresh word every Sunday. Every past week lives here — read, revisit, and share what steadies you.</p>

      <div className="mt-14 space-y-4">
        {list?.length === 0 && <div data-testid="devotionals-empty" className="card-flat p-16 text-center font-serif text-2xl text-[#0a192f]">The first devotional arrives this Sunday.</div>}
        {list?.map((d) => {
          const isOpen = open === d.id;
          return (
            <article key={d.id} data-testid={`devotional-card-${d.id}`} className={`card-flat border-l-4 transition-colors ${isOpen ? "border-[#d4af37]" : "border-transparent hover:border-[#0a192f]"}`}>
              <button data-testid={`devotional-toggle-${d.id}`} onClick={() => setOpen(isOpen ? null : d.id)} className="w-full text-left p-8 flex items-start gap-5">
                <BookOpen className={`w-6 h-6 mt-1 flex-shrink-0 ${isOpen ? "text-[#d4af37]" : "text-[#0a192f]"}`} />
                <div>
                  <div className="text-xs text-[#4a4a4a] tracking-widest uppercase">{new Date(d.created_at).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" })}</div>
                  <h2 className="font-serif text-3xl text-[#0a192f] mt-2 leading-tight">{d.subject}</h2>
                </div>
              </button>
              {isOpen && (
                <div className="px-8 pb-10 pl-[4.75rem] text-[#1a1a1a] leading-relaxed space-y-5 text-base" data-testid={`devotional-content-${d.id}`}>
                  {d.body_text.split(/\n\s*\n/).map((p, i) => <p key={i}>{p}</p>)}
                </div>
              )}
            </article>
          );
        })}
      </div>
    </div>
  );
}
